import { motion } from "framer-motion";
import { Shield, ShieldCheck, Award } from "lucide-react";

const credentials = [
  {
    icon: Shield,
    iconClass: "text-[#FF9900]",
    label: "AWS Developer Associate",
    detail: "Production cloud and desktop delivery",
  },
  {
    icon: ShieldCheck,
    iconClass: "text-emerald-400",
    label: "CompTIA Security+",
    detail: "Security-first product engineering",
  },
  {
    icon: Award,
    iconClass: "text-primary",
    label: "9+ Years Building Products",
    detail: "Desktop and AI apps shipped end to end",
  },
];

export function TrustCredentials() {
  return (
    <section className="relative border-y border-white/5 bg-white/[0.02]">
      <div className="container mx-auto px-6 py-8">
        <motion.p
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-xs font-medium uppercase tracking-widest text-muted-foreground mb-6"
        >
          Built by a credentialed solo engineer
        </motion.p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {credentials.map((item, index) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="flex items-center gap-3 rounded-xl border border-white/8 bg-white/[0.03] px-4 py-3"
            >
              <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                <item.icon className={`h-5 w-5 ${item.iconClass}`} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground leading-tight">
                  {item.label}
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {item.detail}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
